import WellBeingBranchTable from './WellBeingBranchTable'

export default WellBeingBranchTable
